module.exports = __webpack_public_path__ + "static/media/Excel_40x40.5cdbde19.svg";